import PropTypes from 'prop-types'
import React from 'react'
import { VelocityComponent } from 'velocity-react'

import { animations } from 'services/velocity_animations'

import UserAvatarContainer from 'components/common/UserAvatarContainer'
import SvgIcon from 'components/common/SvgIcon'
import GuestName from './GuestName'

import IconMessage from 'src/assets/icons/message_icon.svg'
import styles from './guest-list-row-container.scss'
import { androidObject, isHobnobAndroidClient } from '../../services/utils'

export default class GuestListRow extends React.Component {
  componentDidUpdate (prevProps) {
    if (this.props.invitation && this.props.invitation.rsvp_state !== prevProps.invitation.rsvp_state) {
      this._velocityComponent.runAnimation()
    }
  }

  _velocityComponentRef = (ref) => { this._velocityComponent = ref };

  _renderAvatar () {
    const { invitationUser } = this.props

    return (
      <UserAvatarContainer
        user={invitationUser}
        size={30}
        includeBorder={false}
      />
    )
  }

  _onShowMessage = () => {
    const { onShowMessageModal, invitationUser } = this.props
    const userId = invitationUser.id

    if (isHobnobAndroidClient()) {
      androidObject().launchChatActivity(userId)
    } else {
      onShowMessageModal()
    }
  }

  _renderMessageIcon () {
    const { canMessage, ownInvitation } = this.props
    if (ownInvitation) return null
    const styleName = canMessage ? 'message-icon-active' : 'message-icon'
    return (
      <SvgIcon
        className={styles[styleName]}
        icon={IconMessage}
        onClick={canMessage ? this._onShowMessage : null}
      />
    )
  }

  render () {
    const {
      invitation,
      invitationUser,
      guestName,
      guestCountEnabled,
      childCountEnabled
    } = this.props

    return (
      <VelocityComponent ref={this._velocityComponentRef} animation={animations.pulse}>
        <div className={styles['container']}>
          {this._renderAvatar()}
          <div className={styles['guest-body']}>
            <GuestName
              invitation={invitation}
              guestName={guestName}
              user={invitationUser}
              guestCountEnabled={guestCountEnabled}
              childCountEnabled={childCountEnabled}
            />
          </div>
          {this._renderMessageIcon()}
        </div>
      </VelocityComponent>
    )
  }
}

GuestListRow.propTypes = {
  invitation: PropTypes.object,
  // Overrides the name on the invitation
  guestName: PropTypes.string,
  canMessage: PropTypes.bool.isRequired,
  childCountEnabled: PropTypes.bool,
  invitationUser: PropTypes.object,
  guestCountEnabled: PropTypes.bool,
  onShowMessageModal: PropTypes.func,
  ownInvitation: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/guest_list/GuestListRow.jsx